import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import FlightCategoryReducer, {
  defaultState,
  asyncActions,
} from 'src/ducks/flight-category.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(FlightCategoryReducer, defaultState, asyncActions);
};

type IFlightCategoryContext = ReturnType<typeof useReducer>;

// Having trouble setting initial values, that's why it is cast to the return type of the reducer
const FlightCategoryContext = createContext<Partial<IFlightCategoryContext>>({
  state: defaultState,
}) as React.Context<IFlightCategoryContext>;

const FlightCategoryProvider: React.FC = ({ children }) => {
  const reducer = useReducer();

  return (
    <FlightCategoryContext.Provider value={{ ...reducer }}>
      {children}
    </FlightCategoryContext.Provider>
  );
};

// We create context hook here so that we can able to unit test
// container components that uses this context
export const useFlightCategoryContext = () => useContext(FlightCategoryContext);

export type IUseFlightCategoryContext = ReturnType<
  typeof useFlightCategoryContext
>;

export { FlightCategoryContext, FlightCategoryProvider };
